// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum FuelType {
  Other = "OTHER",
  NaturalGas = "NATURAL_GAS",
  BioMethane = "BIOMETHANE",
  PhevWithLimitedCo2 = "PHEV_WITH_LIMITED_CO2",
}
export default FuelType;
